<template>
  <div class="add-active">
    <div class="up-qrcode">
      <div class="title">
        <span>二维码列表-{{param}}添加活动</span>
      </div>
      <div class="qrcode-info">
        <div class="qr-img">
          <img :src="row.picAddress"/>
        </div>
        <div class="qr-info">
          <span>店铺名称:{{ row.shopName }}</span>
          <span>联系人:{{ row.proposer }}</span>
          <span>联系电话:{{ row.shopPhone }}</span>
          <span>地址:{{ row.district+row.shopAddress }}</span>
        </div>
      </div>
    </div>
    <hr/>
    <div class="down-active">
      <div class="fun-btn">
        <span>推荐绑定活动</span>
        <el-select class="el-select-item padding-l-r" v-model="condition" clearable placeholder="请选择"
                   @change="changeCondition">
          <el-option
            v-for="item in selectCondition"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input class="padding-l-r" clearable v-model="activeId" placeholder="输入活动id"
                  style="width: 250px;" @clear="getActiveList"></el-input>
        <el-button class="padding-l-r" type="primary" @click="getActive">搜索</el-button>
      </div>
      <el-table ref="actives" :data="activeData" v-loading="loading" @selection-change="selectionChange">
        <el-table-column align="center" type="selection"></el-table-column>
        <el-table-column label="id" prop="id" align="center"></el-table-column>
        <el-table-column label="缩略图" align="center">
          <template slot-scope="scope_resource">
            <img style="width: 30%" :src="scope_resource.row.resource">
          </template>
        </el-table-column>
        <el-table-column label="名称" prop="title" align="center"></el-table-column>
        <el-table-column label="营销时间" prop="endTime" align="center" :formatter="formatTime"></el-table-column>
        <el-table-column label="距离" prop="distance" width="150px" align="center">
          <template slot-scope="scope0">
            <span v-if="scope0.row.distance==null">--</span>
            <span v-else>{{ scope0.row.distance }}m</span>
          </template>
        </el-table-column>
        <el-table-column label="余额" prop="remainder" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="bindActive(scope.row)">绑定</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 1% 0px">
        <el-button @click="qrcodeBulkMultiActive">批量绑定</el-button>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="showBind" width="400px" title="绑定选项" @close="bindCancle" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="必出:">
          <el-switch
            v-model="certainlyOut"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="是"
            inactive-text="否"
          ></el-switch>
        </el-form-item>
        <el-form-item align="right">
          <el-button @click="bindCancle">取消</el-button>
          <el-button type="primary" @click="bindConfirm">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        row: {},
        param: '',
        condition: '',
        selectCondition: [
          {
            label: '距离最近',
            value: 1
          },
          {
            label: '余额升序',
            value: 2
          },
          {
            label: '余额降序',
            value: 3
          },
        ],
        activeId: '',
        activeData: null,
        showBind: false,
        certainlyOut: false,
        projectId: null,
        currentPage: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        selectRows: null,
      }
    },
    methods: {
      getQrInfo() {
        this.$http.post(this, '/qrcode/getQrInfo', {param: this.param}).then(res => {
          this.row = res.data
        })
      },
      getActiveList(initVal) {
        this.loading = true
        this.$http.get(this, '/qrcode/getActiveList', {
          param: this.param,
          condition: initVal == undefined ? this.condition : initVal,
          pageSize: this.pageSize,
          currentPage: this.currentPage - 1
        }).then(res => {
          res.data.data.map(item => {
            if (item.distance == 2147483647) {
              item.distance = null
            }
          })
          this.activeData = res.data.data
          this.total = res.data.count
          this.loading = false
        })
      },
      changeCondition() {
        this.getActiveList()
        this.activeId = ''
      },
      formatTime(row, column) {
        if (!row.endTime) {
          return '无限制'
        }
        return new Date(row.endTime).format("yyyy/MM/dd hh:mm");
      },
      getActive() {
        if (null == this.activeId || '' == this.activeId) {
          this.getActiveList()
          return;
        }
        this.condition = ''
        this.$http.post(this, '/qrcode/getActive', {activeId: this.activeId, param: this.param}).then(res => {
          res.data.map(item => {
            if (item.distance == 2147483647) {
              item.distance = null
            }
          })
          this.activeData = res.data
        })
      },
      bindActive(row) {
        this.showBind = true
        this.projectId = row.id
      },
      bindCancle() {
        this.certainlyOut = false;
        this.showBind = false;
      },
      bindConfirm() {
        this.$http.post(this, '/qrcode/bindActive', {
          param: this.param,
          projectId: this.projectId,
          certainlyOut: this.certainlyOut ? 1 : 0
        }).then(res => {
          this.$message({
            message: res.code == 200 ? res.data : res.message,
            type: res.code == 200 ? "success" : "error"
          })
          this.showBind = false
          this.getActiveList()
        })
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getActiveList()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getActiveList()
      },
      selectionChange(val) {
        this.selectRows = val
      },
      qrcodeBulkMultiActive() {
        let activeIds = []
        if (this.selectRows == null || this.selectRows.length == 0) {
          return
        } else {
          this.selectRows.forEach(item => {
            activeIds.push(item.id)
          })
        }
        if (activeIds.length > 0) {
          this.$http.post(this, '/qrcode/qrcodeBulkMultiActive', {
            param: this.param
          }, activeIds).then(res => {
            if (res.code == 200) {
              let success = res.data.success.length > 0 ? '活动:' + res.data.success + '绑定成功.' : ''
              let error = res.data.error.length > 0 ? '活动:' + res.data.error + '绑定失败.' : ''
              if (res.data.success.length > 0) {
                this.$notify({
                  title: '提示',
                  message: success,
                  type: "success"
                })
              }
              if (res.data.error.length > 0) {
                this.$notify({
                  title: '提示',
                  message: error,
                  type: "error"
                })
              }
            } else {
              this.$notify({
                title: '警告',
                message: res.message,
                type: "error"
              })
            }
            this.$refs.actives.clearSelection()
            this.getActiveList()
          })
        } else {
          return;
        }
      },
    },
    created() {
      this.param = this.$route.query.param
      this.getQrInfo()
      this.getActiveList(this.$route.query.condition)
    }
  }
</script>
<style>
  .add-active {
    height: 100%;
  }

  .up-qrcode {
    height: 30%;
  }

  .qrcode-info {
    display: flex;
  }

  .title {
    font-size: 25px;
    font-weight: bold;
    padding: 1% 0px;
  }

  .qr-img {
    width: 10%;

  }

  .qr-img img {
    width: 100%;
  }

  .qr-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0px 1%;
  }

  .el-select-item {
    margin-left: 5%;
  }

  .fun-btn {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .padding-l-r {
    margin: 0px 2%;
  }
</style>
